import React from 'react';
import { LandingInt02 } from './pages/LandingInt02';
// Root path (/*) now shows the Int02 landing page directly.
export function App() {
  return <LandingInt02 data-id="element-0" />;
}